<mat-form-field class="w-100">
    <mat-label>{{ placeholderKey | translate }}</mat-label>
    <input matInput type="text" [formControl]="textFormControl" [matAutocomplete]="autoComplete" (blur)="validate()" />
    <mat-error>
        <sl-form-field-error-control [control]="textFormControl" />
    </mat-error>
    @if (textFormControl.value && !textFormControl.disabled) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearItem()">
            <mat-icon>close</mat-icon>
        </button>
    }
    <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete" (optionSelected)="selectItem($event)">
        @for (item of filteredItems; track item.id) {
            <mat-option [value]="item.label" [id]="item.id">
                {{ item.label }}
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
